<template>
    <div class="row">
        <div class="col-12" v-if="!productChosen">
            <div class="form-group">
                <label>{{$t('COMMON.product')}}</label>
                <multiselect  v-model="productChosen"
                             @remove="productChosen = null"
                             :options="sortedProducts"
                             :close-on-select="true"
                             :hide-selected="false"
                             :preserve-search="true"
                             :multiple="false"
                             trackBy="id"
                             :custom-label="customProductLabel"
                             placeholder="Type"
                             style="z-index: 100;">
                    <template slot="tag" slot-scope="props">
                    <span class="custom__tag">
                        <span>{{ props.option }}</span>
                        <span class="custom__remove"
                              @click="props.remove(props.option)">
                            ❌
                        </span>
                    </span>
                    </template>
                </multiselect>
            </div>
        </div>
        <div class="col-12" v-if="productChosen">
            <h4 class="mt-2">{{$t('PROMOTIONS.standardPrice')}}: {{standardPrice}} {{symbol}}</h4>

            <div class="mt-3"></div>
            <div class="row"> 
                <div class="col-6 col-xs-12">
                    <regular-promotion :productChosen="productChosen"
                                    :regularPromotions="regularPromotions"
                                    :noTable="true"
                                    @addPromotion="addPromotion($event)"
                                    @activate="activatePromotion($event)"
                                    :showadd="showadd"
                                    :symbol="symbol"
                                    >
                    </regular-promotion>
                </div>
                <div class="col-6 col-xs-12 border-left">
                    <bulk-promotions :bulkPromotions="bulkPromotions"
                                    :productChosen="productChosen"
                                    v-if="showBulkPromotions"
                                    :newPromotionData="newBulkPromotion"
                                    @addPromotion="addPromotion($event)"
                                    @activate="activatePromotion($event)"
                                    @remove="removePromotion($event)"
                                    :showadd="showadd"
                                    :noTable="true"
                                    :symbol="symbol">
                    </bulk-promotions>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CphButton from '../../Shared/UI/Button/CphButton.vue';
import FormInput from '../../Shared/UI/Form/FormInput';
import Multiselect from 'vue-multiselect';
import BulkPromotions from './BulkPromotions';
import RegularPromotion from './RegularPromotion';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { utils } from '../../../plugins/utils'
const { uuid } = utils
export default {
    name: 'promotion-form-bulk',
    data () {
        return {
            newPromotion: null,
            newBulkPromotion: null,
            showBulkPromotions: true,
            symbol: 'EUR',
            promotionsForProduct: [],
        };
    },
    computed: {
        productPromotions () {
            if (!this.productChosen) {
                return [];
            }
            return this.promotions.filter(({productId}) => productId === this.productChosen.id);
        },
        bulkPromotions () {
            return this.productPromotions.filter(({type}) => type === 'bulk');
        },
        regularPromotions () {
            return this.productPromotions.filter(({type}) => type === 'period');
        },
        sortedProducts () {
            return this.alphabeticalSort(this.products);
        },
        standardPrice () {
            if (!this.productChosen) {
                return 0;
            }
            return this.productChosen.priceValue;
        },
        productChosen: {
            get (){
                return this.$props.editedProduct;
            },
            set (){

            }
        }
    },
    watch: {
        productChosen (newProduct) {
            this.getPromotions((newProduct));
        }
    },
    components: {
        RegularPromotion,
        BulkPromotions,
        CphButton,
        FormInput,
        Multiselect,
    },
    props: {
        products: {
            type: [Array]
        },
        promotions: {
            type: [Array]
        },
        prices: {
            type: [Object]
        },
        editedProduct: {
            type: Object
        },
        showadd: {
            type: Boolean
        }
    },
    methods: {
        alphabeticalSort (arr) {
            return arr.sort((a, b) => a.type > b.type );
        },
        customProductLabel ({type, formats, code}) {
            return `${type} ${formats[0].displayString} ${code && code !== 'undefined' ? `code: ${code}` : ''}`;
        },
        async addPromotion ({promotion, type}) {
            const promotionWithId = { ...promotion, id: uuid()}
            this.newPromotion = promotionWithId;
            this.newBulkPromotion = promotionWithId;
            try {
                if (promotion.price > this.standardPrice) {
                    return this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.higherPrice'), shouldGoToPrevPage: false,
                        callback: (decision = false) => {
                            if(decision) {
                                this.$emit("addPromotion", promotionWithId)
                                this.newPromotion = null
                                this.newBulkPromotion = null
                            }
                        }});
                } else {
                    this.$emit("addPromotion", promotionWithId)
                }
            } catch (err) {
                console.log(err);
            }
        },
        async removePromotion (id) {
            const updatedPromotions = this.promotions.filter((promo) => promo.id !== id);

            console.log("removePromotion ", updatedPromotions, id);
            this.$store.dispatch('confirmAction', {question: this.$t('QUESTIONS.removePromotion'),
                callback: (decision = false) => {

                    if(decision === true) {
                        //this.updatePromotions(updatedPromotions);
                        this.$emit("updatepromotion", updatedPromotions)
                        // this.$emit("removePromotion", id)
                        return;
                    }
                    this.$emit("removePromotion",  id)
                }
            }).then(test => {
                console.log(test);
            })
        },
        async getPromotions (product) {
            let productPromotions = this.promotions.filter((promo) => promo.id !== id);
            // await this.$store.dispatch('getPromotionByProductIdAsync', product.id);
            if (this.$utils.isArray(productPromotions)) {
                this.promotionsForProduct = productPromotions;
            }
        },
        async activatePromotion (promotion) {
            const acState = {...promotion, active: !promotion.active};
            this.$emit("updatepromotion", acState)
        }
    },
    async created () {
        if(this.editedProduct) {
            this.productChosen = this.products.find(product => product.id === this.editedProduct);
            //this.getPromotions(this.productChosen);
        }
    }
};
</script>
